// src/api/kanban.js
import axios from 'axios'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/neue/admin',
  headers: { 'Content-Type': 'application/json' },
})

// — attach token to every request
apiClient.interceptors.request.use(config => {
  const token = localStorage.getItem('auth_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, err => Promise.reject(err))

// — catch 401s and force relogin
apiClient.interceptors.response.use(
  resp => resp,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

/**
 * Fetch the entire board (lists + cards + comments)
 * @returns { Promise<{ lists: Array }> }
 */
export async function fetchBoard() {
  const res = await apiClient.get('/neue/admin/kanban/board')
  return res.data.lists   // [{ id, title, color, cards: [...] }, …]
}

export async function editCard(card) {
    const res = await apiClient.post('/neue/admin/kanban/card', card)
    return res.data   
  }
  
/**
 * Soft-delete a card by ID.
 */
export async function deleteCard(cardId) {
    const res = await apiClient.delete(`/neue/admin/kanban/card/${cardId}`)
    return res.data
}

export async function addComment(cardId, text) {
    const res = await apiClient.post('/neue/admin/kanban/comment', { cardId, text });
    return res.data.comment;
}
  
export async function fetchNotifications() {
    const res = await apiClient.get('/neue/admin/kanban/notifications')
    return res.data.notifications   // [{ id, user_id, card_id, type, message, is_read, created_at }, …]
}
  
  /**
   * Mark a notification as read
   */
export async function markNotificationRead(notificationId) {
    const res = await apiClient.patch(`/neue/admin/kanban/notifications/${notificationId}`)
    return res.data   // { success: true }
}